import styled from 'styled-components';

import { CarouselFullScreen } from 'components/carousel/CarouselFullScreen';
import { LoadingIndicator } from 'components/ui-elements/LoadingIndicator';
import { useFullScreen } from 'hooks/useFullScreen';
import { InternalMessageDto, MessageInternalStatus } from 'services/message/messageService.dto';

import { MessageDetails } from './MessageDetails';

const MessageImage = styled.img<{ $success: boolean }>`
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
  opacity: ${props => (props.$success ? 1.0 : 0.3)};
`;

const Container = styled.div<{ $isMessageOwner: boolean }>`
  max-width: 220px;
  margin-left: ${props => (props.$isMessageOwner ? 'auto' : '0')};
  margin-right: ${props => (props.$isMessageOwner ? '0' : 'auto')};
  position: relative;
`;

const StyledLoadingIndicator = styled(LoadingIndicator)`
  position: absolute;
  top: 40%;
  right: 45%;
`;

interface Props {
  message: InternalMessageDto;
  isMessageOwner: boolean;
}

export const PhotoMessage = ({ message, isMessageOwner }: Props) => {
  const fullScreenProps = useFullScreen();

  return (
    <Container $isMessageOwner={isMessageOwner}>
      {message.internalStatus === MessageInternalStatus.UPLOADING && <StyledLoadingIndicator />}
      <MessageImage
        data-testid={'message-image'}
        src={message.mediaUrl}
        alt={'msg-img'}
        onClick={fullScreenProps.setFullScreen}
        $success={true}
      />
      <CarouselFullScreen {...fullScreenProps} photos={[message.mediaUrl!!]} />
      <MessageDetails message={message} isMessageOwner={isMessageOwner} />
    </Container>
  );
};
